"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5119],{

/***/ 15119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SectionArticleChapter": function() { return /* binding */ SectionArticleChapter; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(79570);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(16405);
// EXTERNAL MODULE: ../../libs/components/src/index.ts + 122 modules
var src = __webpack_require__(75762);
// EXTERNAL MODULE: ../../libs/styles/src/index.ts + 15 modules
var styles_src = __webpack_require__(55022);
// EXTERNAL MODULE: ../../libs/article/src/index.ts + 2 modules
var article_src = __webpack_require__(82607);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionQuote/SectionQuote.tsx
var SectionQuote = __webpack_require__(14618);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionIconWithTextList/SectionIconWithTextList.tsx
var SectionIconWithTextList = __webpack_require__(89274);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionSingleMediaWithDescription/SectionSingleMediaWithDescription.tsx
var SectionSingleMediaWithDescription = __webpack_require__(79689);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionVideoPlayer/SectionVideoPlayer.tsx
var SectionVideoPlayer = __webpack_require__(96811);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionQuoteWithVideo/SectionQuoteWithVideo.tsx
var SectionQuoteWithVideo = __webpack_require__(56390);
// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionStats/SectionStats.tsx
var SectionStats = __webpack_require__(49197);
;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionExternalArtifact/SectionExternalArtifact.tsx



const DEFAULT_ASPECT_RATIO_WIDTH = 16;
const DEFAULT_ASPECT_RATIO_HEIGHT = 9;
const StyledSectionWrapper = (0,styles_src/* styled */.zo)(src/* SectionWrapper */.Uq, {
    maxWidth: "$richTextWidth"
});
const Figure = (0,styles_src/* styled */.zo)("figure", {
    margin: 0,
    display: "grid",
    rowGap: "$20"
});
const ResponsiveFrameWrapper = (0,styles_src/* styled */.zo)("div", {
    position: "relative",
    width: "100%",
    variants: {
        visible: {
            always: {
                display: "block",
                "@md": {
                    display: "block"
                }
            },
            onlyMobile: {
                display: "block",
                "@md": {
                    display: "none"
                }
            },
            onlyDesktop: {
                display: "none",
                "@md": {
                    display: "block"
                }
            }
        }
    }
});
const Frame = (0,styles_src/* styled */.zo)("div", {
    position: "relative",
    width: "100%"
});
const ArtifactIframe = (0,styles_src/* styled */.zo)("iframe", {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    border: "none"
});
const Caption = (0,styles_src/* styled */.zo)("figcaption", {
    projectFont: "body04",
    color: "$black_06"
});
const buildAspectRatio = (width, height)=>{
    const safeWidth = typeof width === "number" && width > 0 ? width : DEFAULT_ASPECT_RATIO_WIDTH;
    const safeHeight = typeof height === "number" && height > 0 ? height : DEFAULT_ASPECT_RATIO_HEIGHT;
    return "".concat(safeWidth, " / ").concat(safeHeight);
};
const ArtifactFrame = (param)=>{
    let { artifactUrl , title , aspectRatio  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Frame, {
        style: {
            aspectRatio
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtifactIframe, {
                src: artifactUrl,
                sandbox: "allow-scripts",
                loading: "lazy",
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: title
            })
        ]
    });
};
const SectionExternalArtifact = (param)=>{
    let { artifactUrl , artifactUrlMobile , altText , caption , aspectRatioWidth , aspectRatioHeight , aspectRatioMobileWidth , aspectRatioMobileHeight  } = param;
    if (!artifactUrl) {
        return null;
    }
    const title = altText || "External artifact";
    const desktopAspectRatio = buildAspectRatio(aspectRatioWidth, aspectRatioHeight);
    const mobileAspectRatio = buildAspectRatio(aspectRatioMobileWidth !== null && aspectRatioMobileWidth !== void 0 ? aspectRatioMobileWidth : aspectRatioWidth, aspectRatioMobileHeight !== null && aspectRatioMobileHeight !== void 0 ? aspectRatioMobileHeight : aspectRatioHeight);
    const desktopVisibility = artifactUrlMobile ? "onlyDesktop" : "always";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSectionWrapper, {
        type: "RICH_TEXT_SM",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Figure, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveFrameWrapper, {
                    visible: desktopVisibility,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtifactFrame, {
                        artifactUrl: artifactUrl,
                        title: title,
                        aspectRatio: desktopAspectRatio
                    })
                }),
                artifactUrlMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveFrameWrapper, {
                    visible: "onlyMobile",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArtifactFrame, {
                        artifactUrl: artifactUrlMobile,
                        title: title,
                        aspectRatio: mobileAspectRatio
                    })
                }),
                caption && /*#__PURE__*/ (0,jsx_runtime.jsx)(Caption, {
                    children: caption
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../libs/page-builder/src/lib/SectionMedia/SectionMedia.tsx
var SectionMedia = __webpack_require__(87597);
;// CONCATENATED MODULE: ../../libs/page-builder/src/lib/SectionArticleChapter/SectionArticleChapter.tsx













const SectionArticleChapter_StyledSectionWrapper = (0,styles_src/* styled */.zo)(src/* SectionWrapper */.Uq, {
    maxWidth: "$richTextWidth",
    containerSpace: "medium"
});
const ChapterTitle = (0,styles_src/* styled */.zo)("h2", {
    marginBottom: ".75em",
    marginTop: "1.5em",
    projectFont: "heading05"
});
const SectionArticleChapter = (param)=>{
    let { content , title  } = param;
    const registerChapterHeading = (0,article_src/* useRegisterChapterHeading */.bM)();
    const setChapterHeadingVisibility = (0,article_src/* useSetChapterHeadingVisibility */.BH)();
    const unregisterChapterHeading = (0,article_src/* useUnregisterChapterHeading */.yp)();
    const chapterTitleRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (!chapterTitleRef.current || !title) return;
        const chapterHeadingElement = chapterTitleRef.current;
        registerChapterHeading(title);
        const observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            setChapterHeadingVisibility(title, entry.isIntersecting);
        }, {
            root: null,
            threshold: 0
        });
        observer.observe(chapterHeadingElement);
        return ()=>{
            observer.disconnect();
            unregisterChapterHeading(title);
        };
    }, [
        registerChapterHeading,
        setChapterHeadingVisibility,
        title,
        unregisterChapterHeading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionArticleChapter_StyledSectionWrapper, {
        id: title,
        type: "NO_MARGIN",
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChapterTitle, {
                ref: chapterTitleRef,
                "data-article-chapter-title": title,
                children: title
            }),
            content && /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* PortableText */.YI, {
                value: content,
                additionalComponents: {
                    types: {
                        sectionQuote: (props)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionQuote.SectionQuote, {
                                ...props.value
                            });
                        },
                        sectionIconWithTextList: (props)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionIconWithTextList/* SectionIconWithTextList */.Z, {
                                ...props.value
                            });
                        },
                        sectionSingleMediaWithDescription: (props)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionSingleMediaWithDescription.SectionSingleMediaWithDescription, {
                                ...props.value
                            });
                        },
                        sectionVideoPlayer: (props)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionVideoPlayer/* SectionVideoPlayer */.b, {
                                ...props.value
                            });
                        },
                        sectionQuoteWithVideo: (props)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionQuoteWithVideo/* SectionQuoteWithVideo */.s, {
                                ...props.value
                            });
                        },
                        sectionStats: (props)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionStats/* SectionStats */.d, {
                                ...props.value
                            });
                        },
                        sectionExternalArtifact: (props)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionExternalArtifact, {
                                ...props.value
                            });
                        },
                        sectionMedia: (props)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionMedia/* SectionMedia */.k, {
                                ...props.value
                            });
                        }
                    }
                }
            })
        ]
    });
};


/***/ }),

/***/ 87597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ SectionMedia; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);



const SectionMediaWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    overflow: "hidden",
    position: "relative",
    marginBlockEnd: 30,
    width: "100%",
    borderRadius: 8
});
function SectionMedia(param) {
    let { media  } = param;
    if (!media) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionMediaWrapper, {
        children: "mediaPayload" in media ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .Media */ .pU, {
            ...media,
            layout: "responsive",
            disablePlaceholderBackground: true
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .MuxPlayer */ .Ge, {
            playbackId: media.playbackId,
            poster: media.firstFrame,
            isAutoPlay: true
        })
    });
}


/***/ }),

/***/ 56390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ SectionQuoteWithVideo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16405);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30299);
/* harmony import */ var _SectionVideoTestimonials_VideoTestimonial__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78432);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75762);






const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_4__/* .SectionWrapper */ .Uq, {
    gap: "$32",
    display: "grid",
    "@xl": {
        gridTemplateColumns: "340px 1fr"
    },
    borderRadius: "$r3_mobile",
    "@lg": {
        borderRadius: "$r3"
    }
});
const Quote = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("p", {
    projectFont: "heading06",
    marginTop: 0
});
const SectionQuoteWithVideo = (param)=>{
    let { quote , media , personName , personPosition , logo , textColor , backgroundColor , priority  } = param;
    const isMd = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .useMediaQuery */ .ac)("md");
    const [isVideoPlaying, setIsVideoPlaying] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // when the view shifts between mobile and desktop, we want to pause videos to prevent double play
        setIsVideoPlaying(false);
    }, [
        isMd
    ]);
    const handleSlidePlayPause = ()=>setIsVideoPlaying((prevState)=>!prevState);
    const handleOnEnded = ()=>{
        setIsVideoPlaying(false);
    };
    const handleSlideIntersectionChange = (inView)=>{
        if (!inView) {
            setIsVideoPlaying(false);
        }
    };
    const resolvedTextColor = (textColor === null || textColor === void 0 ? void 0 : textColor.rgba) || (textColor === null || textColor === void 0 ? void 0 : textColor.hex);
    const resolvedBackgroundColor = (backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.rgba) || (backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.hex);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        type: "RICH_TEXT_SM",
        css: resolvedBackgroundColor ? {
            backgroundColor: resolvedBackgroundColor
        } : undefined,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__/* .InView */ .df, {
                threshold: 0.6,
                onChange: handleSlideIntersectionChange,
                children: (param)=>/*#__PURE__*/ {
                    let { inView , ref  } = param;
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SectionVideoTestimonials_VideoTestimonial__WEBPACK_IMPORTED_MODULE_3__/* .VideoTestimonial */ .N, {
                        ref: ref,
                        media: media,
                        personName: personName,
                        personPosition: personPosition,
                        logo: logo,
                        priority: priority,
                        play: isVideoPlaying,
                        canHideControlsForVideo: isVideoPlaying,
                        inView: inView,
                        handleOnEnded: handleOnEnded,
                        handleSlidePlayPause: handleSlidePlayPause
                    });
                }
            }),
            quote && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Quote, {
                    css: resolvedTextColor ? {
                        color: resolvedTextColor
                    } : undefined,
                    children: quote
                })
            })
        ]
    });
};


/***/ }),

/***/ 49197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ SectionStats; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);



const StatsWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    rowGap: "$32",
    columnGap: "$32",
    "@md": {
        gridTemplateColumns: "1fr 1fr",
        rowGap: "$72"
    }
});
const Stat = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    gap: "$16",
    "@md": {
        gap: "$24"
    }
});
const ValueWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "flex"
});
const Value = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("span", {
    projectFont: "numbers01"
});
const Symbol = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("span", {
    projectFont: "display02",
    lin: {
        fontSize: [
            30,
            48
        ]
    },
    paddingTop: "$4"
});
const Label = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("p", {
    projectFont: "body03"
});
const SectionStats = (param)=>{
    let { stats  } = param;
    if (!stats || stats.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .SectionWrapper */ .Uq, {
        type: "RICH_TEXT_MD",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StatsWrap, {
            children: stats.map((param, index)=>/*#__PURE__*/ {
                let { label , value , symbol  } = param;
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Stat, {
                    children: [
                        value && symbol && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ValueWrap, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Value, {
                                    children: value
                                }),
                                symbol !== "none" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Symbol, {
                                    children: symbol
                                })
                            ]
                        }),
                        label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Label, {
                            style: {
                                marginTop: 0
                            },
                            children: label
                        })
                    ]
                }, "".concat(index, "-").concat(label));
            })
        })
    });
};


/***/ }),

/***/ 96811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SectionVideoPlayer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75762);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);



const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .SectionWrapper */ .Uq, {
    display: "grid",
    rowGap: "$20"
});
const Description = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("p", {
    projectFont: "body04",
    color: "$black_06"
});
const SectionVideoPlayer = (param)=>{
    let { video , description  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        type: "RICH_TEXT_SM",
        children: [
            video && video.playbackId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_1__/* .MuxPlayer */ .Ge, {
                playbackId: video.playbackId,
                poster: video.firstFrame,
                isAutoPlay: true,
                intersectionObserverOptions: {
                    rootMargin: "200px"
                }
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Description, {
                    children: [
                        "↑ ",
                        description
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 78432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ VideoTestimonial; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16405);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75762);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61349);
/* harmony import */ var _portfolio_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46115);






const hidingAnimation = {
    transition: "transform .7s, opacity .7s",
    variants: {
        hide: {
            true: {
                transform: "translateY(20px)",
                opacity: "0"
            },
            false: {
                transform: "translateY(0)",
                opacity: "1"
            }
        }
    }
};
const Slide = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    color: "$white",
    display: "grid",
    gap: "$32",
    gridTemplateRows: "max-content",
    alignItems: "center",
    cursor: "pointer",
    "-webkit-tap-highlight-color": "transparent",
    variants: {
        inView: {
            false: {
                pointerEvents: "none",
                cursor: "auto"
            }
        }
    }
});
const MediaWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    overflow: "hidden",
    borderRadius: "$r3_mobile",
    "@lg": {
        borderRadius: "$r3"
    },
    transform: "translateZ(0)",
    gridColumn: 1,
    gridRow: 1
});
const ContentWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    alignContent: "flex-end",
    gridColumn: 1,
    gridRow: 1,
    height: "100%",
    paddingBottom: "$32",
    gap: "$24",
    zIndex: "$content",
    overflow: "hidden",
    justifyContent: "center",
    justifyItems: "center",
    borderRadius: "calc($r3_mobile - 1px)",
    "@lg": {
        borderRadius: "calc($r3 - 1px)"
    },
    transform: "translateZ(0)",
    transition: "opacity .7s",
    background: "linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))",
    variants: {
        hide: {
            true: {
                opacity: "0.75"
            },
            false: {
                opacity: "1"
            }
        }
    },
    "@md": {
        gap: "$32"
    }
});
const LogoWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    display: "grid",
    justifySelf: "center",
    maxWidth: 120,
    "@lg": {
        overflow: "hidden",
        height: 50,
        maxWidth: 180,
        width: "100%"
    },
    ...hidingAnimation
});
const TextWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
    ...hidingAnimation
});
const Name = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    projectFont: "body03",
    textAlign: "center"
});
const Position = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)("div", {
    projectFont: "body03",
    textAlign: "center",
    color: "$white_05"
});
const ControlButton = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
    display: "flex",
    margin: "0 auto",
    projectFont: "ui01",
    color: "$white",
    alignItems: "center",
    justifyContent: "center",
    gap: "$8",
    zIndex: "$content",
    "&:focus-visible": {
        outline: "$focusBlue solid 3px;"
    }
});
const VideoTestimonial = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { media , personName , personPosition , logo , play , canHideControlsForVideo , priority , handleOnEnded , handleSlidePlayPause , inView , sectionVideos  } = param;
    const isMd = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_2__/* .useMediaQuery */ .ac)("md");
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("videoTestimonials");
    const hasMobileVideo = (media === null || media === void 0 ? void 0 : media.mediaPayload.type) === "mux-video" && media.mediaPayload.mobileVideo;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Slide, {
        onClickCapture: handleSlidePlayPause,
        ref: ref,
        children: [
            media && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MediaWrap, {
                children: (media === null || media === void 0 ? void 0 : media.mediaPayload.type) === "mux-video" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                    ...media,
                    disablePlaceholderBackground: true,
                    hardcropRatio: "portrait2",
                    layout: "responsive",
                    videoOverride: (video)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Video */ .nk, {
                            alt: media === null || media === void 0 ? void 0 : media.alt,
                            firstFrame: video === null || video === void 0 ? void 0 : video.firstFrame,
                            width: video === null || video === void 0 ? void 0 : video.width,
                            height: video === null || video === void 0 ? void 0 : video.height,
                            muted: false,
                            loop: false,
                            src: video === null || video === void 0 ? void 0 : video.mp4,
                            play: hasMobileVideo ? play && inView && isMd : play && inView,
                            onEnded: handleOnEnded,
                            layout: "responsive",
                            priority: priority,
                            sizes: "(min-width: 1000px) 340px, (min-width: 740px) 300px, 224px"
                        });
                    },
                    videoOverrideMobile: (video)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Video */ .nk, {
                            alt: media === null || media === void 0 ? void 0 : media.alt,
                            firstFrame: video === null || video === void 0 ? void 0 : video.firstFrame,
                            width: video === null || video === void 0 ? void 0 : video.width,
                            height: video === null || video === void 0 ? void 0 : video.height,
                            muted: false,
                            loop: false,
                            src: video === null || video === void 0 ? void 0 : video.mp4,
                            play: hasMobileVideo ? play && inView && !isMd : play && inView,
                            onEnded: handleOnEnded,
                            layout: "responsive",
                            priority: priority,
                            sizes: "(min-width: 1000px) 340px, (min-width: 740px) 300px, 224px"
                        });
                    }
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                    ...media,
                    hardcropRatio: "portrait2",
                    layout: "responsive",
                    sizes: "(min-width: 740px) 240px, (min-width: 1000px) 486px, 290px"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContentWrap, {
                hide: canHideControlsForVideo,
                children: [
                    sectionVideos && isMd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoWrap, {
                        hide: canHideControlsForVideo,
                        children: logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                            ...logo,
                            disablePlaceholderBackground: true,
                            layout: "fill",
                            objectFit: "contain"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TextWrap, {
                        hide: canHideControlsForVideo,
                        children: [
                            personName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Name, {
                                children: personName
                            }),
                            personPosition && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Position, {
                                children: personPosition
                            })
                        ]
                    }),
                    !canHideControlsForVideo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ControlButton, {
                        children: [
                            t("play"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_icons__WEBPACK_IMPORTED_MODULE_5__/* .Play */ .sh, {})
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ControlButton, {
                        children: [
                            t("pause"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_icons__WEBPACK_IMPORTED_MODULE_5__/* .Pause */ .dz, {})
                        ]
                    })
                ]
            }),
            sectionVideos && !isMd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoWrap, {
                hide: canHideControlsForVideo && isMd,
                children: logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_3__/* .Media */ .pU, {
                    ...logo,
                    disablePlaceholderBackground: true,
                    layout: "intrinsic"
                })
            })
        ]
    });
});


/***/ })

}]);